<template>
  <div class="alarm_statu">
    <div id="mainCahrts"></div>
    <div :class="more ? 'more_unit' : 'unit'">
      {{ $t('Company') }}：<i class="unit_icon"></i> {{ unit ? unit : moreUnit }}
    </div>
    <div class="pagination" v-if="more">
      <span>{{ staticProport.currentPage }}/{{ staticProport.totalData }}</span>
      <el-pagination layout="prev,next" @current-change="handleTraceChange" :current-page="staticProport.currentPage"
        :page-size="staticProport.pageSize" :total="staticProport.totalUser">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { splitArray } from '@/util/common'
import { mapGetters } from 'vuex'
export default {
  props: {
    traceData: {
      type: Object,
    },
    XData: {
      type: Array,
    },
    unit: {
      type: String,
    },
    more: {
      type: Boolean,
    },
  },
  data() {
    return {
      myChart: {},
      Xdata: [],
      Data: [],
      staticProport: { totalUser: 0, currentPage: 1, totalData: 0, pageSize: 16, XuserData: [], onlineData: [] },
      moreUnit: '',
      // X轴字体颜色
      color: '',
      labelColor: '',
      splitLineColor: '',
      
    }
  },
  methods: {
    // 轨迹切换分页
    handleTraceChange(val) {
      this.staticProport.currentPage = val
      this.Xdata = this.staticProport.XuserData[val - 1]
      this.Data = this.staticProport.onlineData[val - 1]
      this.initCharts()
    },
    // 做数据截取
    arrayChunk() {
      // 页数向上取整
      let proportPage = Math.ceil(this.traceData.allXData.length / 16)
      // 总页数
      this.staticProport.totalUser = this.traceData.allXData.length
      this.staticProport.totalData = proportPage
      this.staticProport.XuserData = splitArray(this.traceData.allXData, 16)
      this.staticProport.onlineData = splitArray(this.traceData.allData, 16)
      // 第一页数据
      this.Xdata = this.staticProport.XuserData[0]
      this.Data = this.staticProport.onlineData[0]
      this.initCharts()
    },
    initCharts() {
      this.$nextTick(() => {
        this.myChart = this.$echarts.init(document.getElementById('mainCahrts'))
        if (!this.more) {
          this.Xdata = this.traceData.traceXAxis
          this.Data = this.traceData.distantData
        }

        let colorOne = new this.$echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(67, 144, 250, 0.9)', // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: 'rgba(67, 144, 250, 0.8)', // 50% 处的颜色
            },
            {
              offset: 1,
              color: '#00FEFF', // 100% 处的颜色
            },
          ],
          false
        )
        let colorTwo = new this.$echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(67, 144, 250, 0.9)', // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: 'rgba(67, 144, 250, 0.9)', // 50% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(67, 144, 250, 0.9)', // 100% 处的颜色
            },
          ],
          false
        )
        this.myChart.setOption({
          roam: false, // 禁止滚轮事件
          tooltip: {
            how: true,
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              var paramData = params[0]
              return paramData.axisValue + '<br/>' + paramData.value
            },
          },
          grid: {
            x: '3%', //距离左边
            x2: '3%', //距离右边
            y: '20%', // 上距离
            y2: '8%', // 下距离
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: this.Xdata,
            axisLabel: {
              //展示角度
              rotate: 20,
              textStyle: {
                color: this.color,
              },
              formatter: function (params) {
                var newParamsName = '' // 最终拼接成的字符串
                var paramsNameNumber = params.length // 实际标签的个数
                var provideNumber = 4 // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
                var language = localStorage.getItem('lang')
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (language === 'en') {
                  newParamsName = params
                } else {
                  if (paramsNameNumber > provideNumber) {
                    /** 循环每一行,p表示行 */
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = '' // 表示每一次截取的字符串
                      var start = p * provideNumber // 开始截取的位置
                      var end = start + provideNumber
                      // 此处特殊处理最后一行的索引值
                      if (p == rowNumber - 1) {
                        // 最后一次不换行
                        tempStr = params.substring(start, paramsNameNumber)
                      } else {
                        // 每一次拼接字符串并换行
                        tempStr = params.substring(start, end) + '\n'
                      }
                      newParamsName += tempStr // 最终拼成的字符串
                    }

                  } else {
                    // 将旧标签的值赋给新标签
                    newParamsName = params
                  }
                }
                //将最终的字符串返回
                return newParamsName
              },
            },
            axisLine: {
              lineStyle: {
                color: this.splitLineColor, //更改坐标轴颜色
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: this.color,
              },
              
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.splitLineColor,
              },
            },
            axisLine: {
              show: false,
            },
          },
          series: [
            {
              tooltip: {
                show: true,
              },
              data: this.Data,
              name: this.unit,
              type: 'bar',
              barWidth: 10,
              // barGap: 200,
              barCategoryGap: 200,
              label: {
                show: true, // 柱子顶部的数值
                position: 'top',
                top: 0,
                fontSize: 6,
                offset: [0, -10],
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorOne
                  },
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: {
                      //数值样式
                      color: this.labelColor,
                      fontSize: 12,
                    },
                  },
                },
              },
              barGap: 0,
            },
            {
              type: 'bar',
              name: this.unit,
              barWidth: 4,
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorTwo
                  },
                },
              },
              barGap: 0,
              data: this.Data,
            },
            {
              name: this.unit,
              tooltip: {
                show: true,
              },
              type: 'pictorialBar',
              itemStyle: {
                borderWidth: 0,
                borderColor: '#00FEFF',
                color: '#00FEFF',
              },
              symbol: 'path://M 0,0 l 120,0 l -30,60 l -120,0 z',
              symbolSize: ['13', '3'],
              symbolOffset: ['-1', '-2'], // 左右 ，上下
              symbolRotate: 0,
              symbolPosition: 'end',
              data: this.Data,
              z: 3,
            },
          ],
        })
      })
    },
  },
  mounted() {
    // this.initCharts()
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler(val) {
        if (val) {
          this.color = '#333'
          this.labelColor = '#1C76DD'
          this.splitLineColor = 'rgba(210, 210, 210, 0.5)'
        } else {
          this.color = '#fff'
          this.labelColor = '#00E4FF'
          this.splitLineColor = 'rgba(101, 198, 231, 0.2)'
        }
        this.initCharts()
      },
    },
    traceData: {
      handler(val) {
        this.initCharts()
      },
      deep: true,
    },
    more: {
      immediate: true,
      handler(val) {
        if (this.more) {
          this.moreUnit = this.traceData.unit
          this.arrayChunk()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.alarm_statu
  height: 100%
  width 100%
  position: relative
  #mainCahrts
    height: 100%
    width 100%
  .pagination
    position absolute
    top 2%
    right 10%
    display flex
    span
      height: 30px;/*no*/
      line-height: 30px;/*no*/
      color #333
.unit_icon
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  margin-right 5px
  background: rgba(67, 144, 250, 0.8)

>>>.el-pagination button:disabled, >>>.el-pagination .btn-next, >>>.el-pagination .btn-prev
  background var(--table-pagination-bg-color)
// 深色样式
.theme-dark
  .pagination
    span
      color #fff
</style>
